import { useSelector } from "react-redux";
import NotFound from "./NotFound";
import { Outlet } from "react-router-dom";

const Editor = () => {
    const user = useSelector((state) => state.user.details);
    return (user?.roleId == 1 || user?.roleId == 2)? <Outlet /> : <NotFound />
}

export default Editor